module.exports = __webpack_public_path__ + "static/media/map-marker.13bdff25.svg";